import { FileChecksum } from "@rails/activestorage/src/file_checksum";

import { presignBlobsMutation } from "@/services/lukita/mutations";
import CalculateChecksumFactory from "./calculate-checksum";
import PresignBlobsFactory from "./presign-blobs";
import uploadFile from "./upload-file";
import useDirectUpload from "./use-direct-upload";

export function useUpload() {
  const calculateChecksum = CalculateChecksumFactory(FileChecksum.create);
  return useDirectUpload(
    PresignBlobsFactory(calculateChecksum, presignBlobsMutation),
    uploadFile,
  );
}
